import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/app/environments/environment';
import { Apps } from 'src/app/shared/enums/enums';
import { normalizeAppName } from 'src/app/shared/models/shared.models';
import { AppsModel, LicenseAttributesModel, LicensesModel } from '../models/subscription.models';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionService {
  private companyApiUrl = environment.companyApiUrl;

  constructor(private http: HttpClient) {}

  getAllApps() {
    const url = `${this.companyApiUrl}/Licenses`;
    return this.http.get(url);
  }

  //Logic for format the  apps array on cilent side
  formatAppListing(appsList: AppsModel[]): AppsModel[] {
    appsList = appsList.filter((item) => item.id < Apps.AdminPortal);
    const appConfigMap: { [key: number]: string } = {
      1: 'assets/images/subscription/TPMLogo.png',
      2: 'assets/images/subscription/POSLogo.png',
      3: 'assets/images/users-management/donationlogo.svg',
      4: 'assets/images/subscription/ListerLogo.png',
    };

    appsList.forEach((app: AppsModel, i: number) => {
      const appIcon = appConfigMap[app.id];

      //Temp Condition for managing the single record if not available
      if (!app.licenses.length) {
        let licenseObj = new LicensesModel();
        let attrObj = new LicenseAttributesModel();
        licenseObj.licenseAttributes.push(attrObj);
        app.licenses.push(licenseObj);
      }

      if (appIcon) {
        app.appIcon = appIcon;
      }

      app.name = normalizeAppName(app.id, app.name);
    });

    return appsList;
  }

  editAppDefaultPricing(data: any) {
    const url = `${this.companyApiUrl}/Licenses/Bulk`;
    return this.http.put(url, data);
  }

  getAllSubscriptionPlan(appIds?: string) {
    let url = `${this.companyApiUrl}/SubscriptionPlans`;

    if (appIds) {
      url += `?AppIds=${appIds}`;
    }

    return this.http.get(url);
  }

  appSubscriptionPlan(data: any) {
    const url = `${this.companyApiUrl}/SubscriptionPlans`;
    return this.http.post(url, data);
  }

  getSubscriptionPlanById(planId: number) {
    const url = `${this.companyApiUrl}/SubscriptionPlans/${planId}`;
    return this.http.get(url);
  }

  editSubscriptionPlan(data: any) {
    const url = `${this.companyApiUrl}/SubscriptionPlans/${data.id}`;
    return this.http.put(url, data);
  }

  deleteSubscriptionPlan(planId: number) {
    const url = `${this.companyApiUrl}/SubscriptionPlans/${planId}`;
    return this.http.delete(url);
  }

  toggleCanShowOnWebsite(subscriptionPlanId: number) {
    const url = `${this.companyApiUrl}/SubscriptionPlans/${subscriptionPlanId}/ToggleCanShowOnWebsite`;
    return this.http.put(url, {});
  }
}

